<template>
  <b-modal :id="id" @close="clean" @hidden="clean" @ok="confirm" ok-title="Отправить" header-bg-variant="light" header-text-variant="info" ok-variant="info" size="md">
    <template #modal-title>
      <b-icon icon="envelope-fill" variant="info" class="mr-2"/>
      Отправить тестовое письмо
    </template>
    <b-form @submit="confirm">
      <p class="text-muted">
        Письмо будет отправлено через SMTP-сервер, указанный в настройках.
      </p>
      <b-form-group
        label="Email получателя"
        description="Введите адрес, на который нужно отправить тестовое письмо"
        :invalid-feedback="invalidEmail"
        :state="emailState">
        <b-form-input
          type="email"
          v-model="to"
          placeholder="[email protected]"
          :state="emailState"/>
      </b-form-group>
      <b-alert v-if="result" :variant="result.success ? 'success' : 'danger'" show class="mt-3">
        <b-icon :icon="result.success ? 'check-circle-fill' : 'x-circle-fill'"/>
        <strong class="ml-2">{{ result.success ? 'Готово' : 'Ошибка' }}</strong>
        <div class="mt-1">{{ result.success ? result.message : result.error }}</div>
      </b-alert>
    </b-form>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'testEmailModal',
  mixins: [RekonoApi],
  props: {
    id: String
  },
  data () {
    return {
      to: null,
      emailState: null,
      invalidEmail: 'Введите корректный email',
      result: null,
      sending: false
    }
  },
  methods: {
    confirm (event) {
      event.preventDefault()
      this.result = null
      // Простая валидация email
      const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      this.emailState = re.test(this.to || '')
      if (this.emailState && !this.sending) {
        this.sending = true
        this.post(`/api/system/1/test-email/`, { to: this.to }, 'Email', '')
          .then(() => {
            this.result = { success: true, message: `Тестовое письмо отправлено на ${this.to}` }
            this.sending = false
          })
          .catch(err => {
            const data = err?.response?.data
            this.result = { success: false, error: data?.error || data?.detail || JSON.stringify(data) || 'Неизвестная ошибка' }
            this.sending = false
          })
      }
    },
    clean () {
      this.to = null
      this.emailState = null
      this.result = null
      this.sending = false
    }
  }
}
</script>
